<div class="mtm-loading__container" [attr.aria-label]="ariaLabel" role="status" aria-live="polite">
  <div class="mtm-loading__ring" [style]="ringStyles"></div>
  @if (label) {
    <div class="mtm-loading__text" [style.color]="textColor">{{ label }}</div>
  }
</div>
